import React, { memo, useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { SectionTitle } from '.';
import { useEPMContext } from '../../../../contexts/EPMContext';
import { useUserContext } from '../../../../contexts/UserContext';
import { permission } from '../../../../config/permission';
import EpmTagPicker from '../../EpmTagPicker';
import { notifyAutoSaved } from '../useAutoSave';

const TagSection = memo(({ testData, setTestData }) => {
    const { updateTest } = useEPMContext();
    const { checkPermission } = useUserContext();
    const canUpdate = checkPermission(permission.XCM_TESTS_UPDATE);

    const [isUpdatingTag, setIsUpdatingTag] = useState(false);

    const testId = testData?._id || testData?.id;
    const tagIds = testData?.tag_ids || [];

    const handleChange = useCallback(async (newTagIds) => {
        if (!canUpdate || !testId) return;

        setIsUpdatingTag(true);
        try {
            await updateTest(testId, { tag_ids: newTagIds });
            notifyAutoSaved();
            if (setTestData) {
                setTestData((prev) => ({ ...prev, tag_ids: newTagIds }));
            }
        } catch (error) {
            console.error('Failed to update tags:', error);
            toast.error(error?.message || 'Failed to update tags');
        } finally {
            setIsUpdatingTag(false);
        }
    }, [testId, updateTest, setTestData]);

    return (
        <section className="epm-idea__card">
            <SectionTitle>Tags</SectionTitle>
            <EpmTagPicker
                selectedTagIds={tagIds}
                onChange={handleChange}
                disabled={!canUpdate || isUpdatingTag}
                id="epm-idea-tag-picker"
            />
        </section>
    );
});

export default TagSection;
